export const PATHS = {
  landing: '/',
  doctors: '/doctors',
  doctorDetail: '/doctors/:id',
  login: '/login',
  loginSms: '/login/sms',
  register: '/register',
  forgotPassword: '/forgot-password',

  home: '/home',
  book: '/book/:doctorId',
  bookingSuccess: '/book/success/:id',
  appointments: '/appointments',
  appointmentDetail: '/appointments/:id',
  reschedule: '/appointments/:id/reschedule',
  notifications: '/notifications',
  clinic: '/clinic',
  history: '/appointments?tab=past',
  profile: '/profile',
  profileEdit: '/profile/edit',
  changePassword: '/profile/password',
};

/** toPath(PATHS.doctorDetail, { id: 'd1' }) -> '/doctors/d1' */
export const toPath = (pattern, params = {}) =>
  pattern.replace(/:([a-zA-Z]+)/g, (_, k) => encodeURIComponent(params[k] ?? ''));
